import { ROLE_VALUES, Role } from "../types/onboarding";

// Export ALL_ROLES from the single source of truth
export const ALL_ROLES = ROLE_VALUES;

// Shared role constants - subsets of all roles
export const STUDENT_ROLES: Role[] = ["undergrad", "graduate-student"];

export const ACADEMIC_ROLES: Role[] = [
  "undergrad",
  "graduate-student",
  "faculty",
];

// Helper functions
export const isStudentRole = (role: string | undefined | null): boolean => {
  if (!role) return false;
  return STUDENT_ROLES.includes(role as Role);
};

export const isAcademicRole = (role: string | undefined | null): boolean => {
  if (!role) return false;
  return ACADEMIC_ROLES.includes(role as Role);
};
